module.exports = __webpack_public_path__ + "img/img_1.5b3f3a8e.png";